import { Button, Modal, Tabs } from 'antd';
import i18next from "i18next";
import { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { MapUtilities } from '../../../../utilities/MapUtilities';
import MapImageLayersInfoComponent from './MapImageLayersInfoComponent';
import { BorderBottomOutlined, BorderOuterOutlined, ThunderboltOutlined, ZoomInOutlined } from '@ant-design/icons';
import { DraggableOnStart } from "../management/utils/DraggableOnStart";
import { ZoomIn } from "../management/utils/ZoomIn";
import { Flash } from "../management/utils/Flash";
import { isMobile } from 'react-device-detect';

const MapToolInfoComponent = ({ mapDiv, mapView, table,
    mapConfig, event, setEvent }) => {

    const [showModalBody, setShowModalBody] = useState(true)
    const [isHoverMinimizeBt, setIsHoverMinimizeBt] = useState(false)
    const [resultTabItems, setResultTabItems] = useState([])

    const [geometry, setGeometry] = useState()
    const [geometryType, setGeometryType] = useState()

    const infoResult = useRef();

    const mapUtilities = new MapUtilities(mapDiv, mapView, mapConfig);

    var mapImageLayers = mapUtilities.getMapImageLayers(true);
    var wmsLayers = mapUtilities.getWMSLayers(true);


    const [disabled, setDisabled] = useState(false);
    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });
    const draggleRef = useRef(null);

    const handleOk = (e) => {
        setEvent(null);
    };

    const handleCancel = (e) => {
        setEvent(null);
    };

    const onStart = (_event, uiData) => {
        DraggableOnStart(_event, uiData, draggleRef, setBounds)
        _event.stopPropagation();
    };

    const onChangeTab = (key) => {
        //console.log("onChangeTab ", infoResult.current.getCurrentTabResult()[key])
        let currentTabResult = infoResult.current.getCurrentTabResult()[key];
        if (currentTabResult) {
            setGeometry(currentTabResult.feature.geometry);
            setGeometryType(currentTabResult.feature.geometry.type);
        }
    };

    const expandStyle = {
        position: "absolute",
        fontSize: "18px",
        top: "19px",
        insetInlineEnd: "40px",
        zIndex: 1010,
        padding: 0,
        color: "rgba(0, 0, 0, 0.45)",
        cursor: "pointer",
        backgroundColor: isHoverMinimizeBt ? "#dee3ed" : "transparent"
    }

    return (
        <>
            <Modal style={{ float: "left", marginLeft: "4%" }}
                width={isMobile ? "90%" : "40%"}
                mask={true}
                maskClosable={false}
                title={
                    <div
                        style={{
                            width: '100%',
                            cursor: 'move',
                        }}
                        onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false);
                            }
                        }}
                        onMouseOut={() => {
                            setDisabled(true);
                        }}
                        // fix eslintjsx-a11y/mouse-events-have-key-events
                        // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/mouse-events-have-key-events.md
                        onFocus={() => {
                        }}
                        onBlur={() => {
                        }}
                    // end
                    >
                        {i18next.t('common.tools.info.name')}

                        {showModalBody && <BorderBottomOutlined
                            onMouseEnter={(e) => setIsHoverMinimizeBt(true)}
                            onMouseLeave={(e) => setIsHoverMinimizeBt(false)}
                            onClick={(e) => setShowModalBody(!showModalBody)}
                            style={expandStyle} />}
                        {!showModalBody && <BorderOuterOutlined
                            onMouseEnter={(e) => setIsHoverMinimizeBt(true)}
                            onMouseLeave={(e) => setIsHoverMinimizeBt(false)}
                            onClick={(e) => setShowModalBody(!showModalBody)}
                            style={expandStyle} />}

                    </div>

                }

                open={true}
                onOk={handleOk}
                onCancel={handleCancel}
                bodyStyle={{
                    maxHeight: window.innerHeight * 0.7,
                    overflow: "auto",
                    height: showModalBody ? "auto" : "0px"
                }}
                modalRender={(modal) => {
                    if (isMobile) {
                        return <div style={{ width: "100%", height: "100%" }}>{modal}</div>
                    }
                    else {
                        return <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                        >
                            <div ref={draggleRef}>{modal}</div>
                        </Draggable>
                    }
                }}
                footer={""
                    /*[
                       <Button id="flash" type="reset" onClick={() => flash()}><ThunderboltOutlined/></Button>,
                       <Button id="zoom" type="reset" onClick={() => zoom()}><ZoomInOutlined/></Button>
                   ]*/
                }
            >
                <Tabs defaultActiveKey="1" items={resultTabItems} onChange={onChangeTab} />
                <MapImageLayersInfoComponent ref={infoResult} mapUtilities={mapUtilities} mapView={mapView} table={table}
                    mapImageLayers={mapImageLayers} resultTabItems={resultTabItems}
                    setResultTabItems={setResultTabItems} event={event}
                    setGeometry={setGeometry} setGeometryType={setGeometryType}
                />
            </Modal>
        </>
    );
}

export default MapToolInfoComponent;